export const CURSOR_BLINK_ANIMATION_DURATION_MS = 7000;
export const TEXT_ANIMATION_DURATION_MS = 6000;
